import { RefundConfiguration } from './refund-configuration'

export const RDV_SURPLUS_TYPES = ['FIXED', 'PERCENTAGE'] as const
export type RDVSurplusType = (typeof RDV_SURPLUS_TYPES)[number]

// Extra credit on a gift card or promo code refund, offered when every expression in whens matches.
export interface RDVSurplusRule {
  type: RDVSurplusType
  // EUR cents for FIXED, converted to the order currency; a percentage of that refund for PERCENTAGE.
  value: number
  whens: string[]
}

// The Refunds tab: the refund configuration and, while the group's RDV surplus is on v2, its rules.
export interface RefundsSettings extends RefundConfiguration {
  rdvSurplus?: RDVSurplusRule[]
}

// settings-api's bound for every cents amount, as the backoffice checks it.
export const MAX_SURPLUS_CENTS = 100_000_000_000

// The rows settings-api would reject: an amount or a percentage out of range.
export const invalidRDVSurplusRules = (rules: RDVSurplusRule[] = []) =>
  rules.flatMap((rule, i) => {
    const valid =
      rule.type === 'FIXED'
        ? Number.isSafeInteger(rule.value) &&
          rule.value >= 0 &&
          rule.value <= MAX_SURPLUS_CENTS
        : Number.isFinite(rule.value) && rule.value >= 0 && rule.value <= 100
    return valid ? [] : [i]
  })

// What a merchant types, with a comma or a dot as decimal separator; empty means none, and NaN marks a typo.
export const parseSurplusAmount = (text: string) => {
  const value = text.trim().replace(',', '.')
  if (value === '') return 0
  return /^\d+(\.\d{0,2})?$/.test(value) ? Math.round(Number(value) * 100) : NaN
}

export const parseSurplusPercentage = (text: string) => {
  const value = text.trim().replace(',', '.')
  if (value === '') return 0
  return /^\d+(\.\d*)?$/.test(value) ? Number(value) : NaN
}
